import api from "../../utils/apiUser";

export const getMarcas = async () => {
  const res = await api.get("/api/marcas");
  return res.data;
};

export const crearMarca = async (data) => {
  const isFormData = data instanceof FormData;

  const res = await api.post("/api/marcas", data, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : undefined,
  });

  return res.data;
};

export const actualizarMarca = async (id, data) => {
  const isFormData = data instanceof FormData;

  const res = await api.put(`/api/marcas/${id}`, data, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : undefined,
  });

  return res.data;
};
